import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  getTaskManagementRemindTypeListPaginated,
  IFullTaskManagementRemindTypeModel,
} from "api";
import { GraphqlDataSchema, Nullable } from "config";
import { RootState } from "store";

import { RemindTypeModalModes } from "./enums";
import { IRemindTypeModalData } from "./types";

const initialState = {
  remindTypeData: null as Nullable<
    GraphqlDataSchema<IFullTaskManagementRemindTypeModel>["edges"]
  >,
  totalCount: 1,
  loading: false,
  modalData: {
    mode: RemindTypeModalModes.VIEW,
    open: false,
  } as IRemindTypeModalData,
};

const remindTypeName = "remind-type";

export const fetchRemindTypeList = createAsyncThunk(
  `${remindTypeName}/fetchRemindTypeList`,
  async (_, { getState }) => {
    const filters = (getState() as RootState).FiltersReducer;
    if (!Object.values(filters).length) {
      return;
    }
    const response = await getTaskManagementRemindTypeListPaginated(filters);
    return response;
  }
);

const remindTypeSlice = createSlice({
  name: remindTypeName,
  initialState,
  reducers: {
    setRemindTypeModalData: (
      state,
      action: PayloadAction<IRemindTypeModalData>
    ) => {
      state.modalData = action.payload;
    },
    closeRemindTypeModal: (state) => {
      state.modalData = initialState.modalData;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchRemindTypeList.fulfilled, (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          loading: false,
        };
      }
      return {
        ...state,
        remindTypeData: action.payload?.edges,
        totalCount: action.payload?.totalCount,
        loading: false,
      };
    });
    builder.addCase(fetchRemindTypeList.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
  },
});

export const { setRemindTypeModalData, closeRemindTypeModal } =
  remindTypeSlice.actions;

export default remindTypeSlice.reducer;
